"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLevelId = exports.levels = void 0;
const input_parser_1 = __importDefault(require("./common/input-parser"));
const utility_1 = require("./common/utility");
const web_console_1 = __importDefault(require("./writers/web-console"));
const levels = ["debug", "info", "warn", "error", "none"];
exports.levels = levels;
class Logger {
    /**
     * Creates an instance of Logger.
     *
     * @param {object} opts Dependencies object { writer, formatter, context }
     *                      "context" is user-defined, and is passed to the formatter.
     *                      This can be used to persist context information across multiple logs entries
     *                      "formatter" is a function accepting a single argument, the object passed to a log method
     *                      "writer" accepts a single
     *
     */
    constructor(opts) {
        this.writers = opts.writer ? utility_1.asArray(opts.writer) : new web_console_1.default();
        this.context = opts.context;
        this.level = opts.level || "debug";
        this.onLog = opts.onLog;
    }
    /**
     * Set the minimum displayed log level
     *
     * @param {string} level The log level
     * @return {void}
     */
    set level(level) {
        const levelId = getLevelId(level);
        if (levelId < 0) {
            throw new Error(`Unknown log level ${level}`);
        }
        this._level = levelId;
    }
    get level() {
        return this._level;
    }
    debug(obj) {
        return this.log("debug", obj);
    }
    info(obj) {
        return this.log("info", obj);
    }
    warn(obj) {
        return this.log("warn", obj);
    }
    error(obj) {
        return this.log("error", obj);
    }
    clone(deps, level) {
        return new Logger(Object.assign({
            level: level || this.level,
            writer: this.writer,
            context: this.context
        }, deps));
    }
    /**
     * Log the passed string or object.
     *
     * @param {string} level  The log level 'debug', info', 'warn', or 'error'
     * @param {any} obj The log - a string, Error object, or structured object
     * @returns {string} a uuid for the log
     */
    log(level, obj) {
        if (arguments.length < 2) {
            obj = level || "";
            level = obj instanceof Error ? "error" : "info";
        }
        let levelId = getLevelId(level);
        if (levelId < this.level) {
            return;
        }
        const writeObj = Object.assign(input_parser_1.default(obj), {
            level: levels[levelId],
            timestamp: new Date(),
            context: this.context,
            id: utility_1.uuid()
        });
        try {
            if (this.onLog && this.onLog(writeObj) === false) {
                return;
            }
        }
        catch (e) { }
        return this.write(writeObj);
    }
    write(obj) {
        let levelId = getLevelId(obj.level);
        this.writers.forEach(writer => {
            if (canWrite(writer, levelId, obj)) {
                try {
                    writer.write(obj);
                }
                catch (e) { }
            }
        });
        return obj;
    }
}
function canWrite(writer, levelId, obj) {
    return !((writer.source && writer.source.indexOf(obj.source) < 0) ||
        levelId < writer.levelId);
}
function getLevelId(level) {
    const text = typeof level === "string" ? level : "";
    return levels.indexOf(text.toLowerCase());
}
exports.getLevelId = getLevelId;
/**
 * Monkey patch a native "console" to use methods from a  logger instead
 *
 * @param {object} con The console to patch
 * @param {Logger} logger The logger
 * @returns {void}
 */
function patchConsole(con, logger) {
    // monkey patch console so that all logging is passed through out logger.
    ["debug", "info", "warn", "error"].forEach(method => {
        con[method] = logger[method].bind(logger);
    });
    con.log = logger.info.bind(logger);
}
Logger.patchConsole = patchConsole;
exports.default = Logger;
//# sourceMappingURL=logger.js.map